import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const cadastrarCampanha = (campanha) => {
  return axios.post(`${process.env.URL_API_BASE}/campanha-cliente`, campanha, config)
}

const createClient = (name) => {
  return axios.post(`${process.env.URL_API_BASE}/clientes`, { name }, config)
}

const listClients = () => {
  return axios
    .get(`${process.env.URL_API_BASE}/clientes`, config)
    .then(response => response.data)
}

const getCampanha = (codigoCampanha) => {
  return axios
    .get(`${process.env.URL_API_BASE}/campanha-cliente/${codigoCampanha}`, config)
    .then(response => response.data)
}

const updateCampanha = (payload) => {
  return axios.put(
    `${process.env.URL_API_BASE}/campanha-cliente/${payload.cd_campanha}`,
    payload.campanha,
    config
  )
}

const listarCampanha = () => {
  return axios
    .get(`${process.env.URL_API_BASE}/campanha-cliente`, config)
    .then(response => response.data)
}

const getProduto = (codigoCampanha, codigoCampanhaProduto) => {
  return axios
    .get(`${process.env.URL_API_BASE}/campanha-cliente/${codigoCampanha}/produto/${codigoCampanhaProduto}`, config)
    .then(response => response.data)
}

const inserirProduto = (codigoCampanha, produto) => {
  return axios.post(`${process.env.URL_API_BASE}/campanha-cliente/${codigoCampanha}/produto`, produto, config)
}

const updateProduto = (codigoCampanha, produto) => {
  return axios.put(
    `${process.env.URL_API_BASE}/campanha-cliente/${codigoCampanha}/produto/${produto.codigoCampanhaProduto}`,
    produto,
    config
  )
}

const deleteProduto = (codigoCampanha, codigoCampanhaProduto) => {
  return axios
    .delete(`${process.env.URL_API_BASE}/campanha-cliente/${codigoCampanha}/produto/${codigoCampanhaProduto}`, config)
    .then(response => response.data)
}

const getArquivo = (codigoCampanha, codigoCampanhaArquivo) => {
  return axios
    .get(`${process.env.URL_API_BASE}/campanha-cliente/${codigoCampanha}/arquivo/${codigoCampanhaArquivo}`, config)
    .then(response => response.data)
}

const inserirArquivo = (codigoCampanha, arquivo) => {
  return axios.post(`${process.env.URL_API_BASE}/campanha-cliente/${codigoCampanha}/arquivo`, arquivo, config)
}

const updateArquivo = (codigoCampanha, arquivo) => {
  return axios.put(
    `${process.env.URL_API_BASE}/campanha-cliente/${codigoCampanha}/arquivo/${arquivo.codigoCampanhaArquivo}`,
    arquivo,
    config
  )
}

const deleteArquivo = (codigoCampanha, codigoCampanhaArquivo) => {
  return axios
    .delete(`${process.env.URL_API_BASE}/campanha-cliente/${codigoCampanha}/arquivo/${codigoCampanhaArquivo}`, config)
    .then(response => response.data)
}

export default {
  cadastrarCampanha,
  listarCampanha,
  createClient,
  listClients,
  getCampanha,
  updateCampanha,
  getProduto,
  inserirProduto,
  updateProduto,
  deleteProduto,
  getArquivo,
  inserirArquivo,
  updateArquivo,
  deleteArquivo
}



// WEBPACK FOOTER //
// ./src/actions/CampanhasActions.js